<template>
  <div
    style="
      background: white;
      color: black;
      margin: 0;
      padding: 0;
      height: 100%;
      width: 100%;
    "
    id="myDivCalen"
  >
    <div class="inner-div1">
      <vs-row class="al-center" vs-w="12">
        <vs-spacer />
        <h3>
          <b>{{ currentTime }}</b>
        </h3>
        <vs-icon
          v-if="showIcon"
          @click="hideSideBar('myDivCalen')"
          icon="zoom_out_map"
          size="25px"
          color="#6c757d"
        ></vs-icon>
        <div class="img" v-else @click="showSideBar"></div>
      </vs-row>
      <vs-row style="width: 100%; height: 96vh" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-lg="7"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-row>
            <vs-card
              style="
                background: rgba(255, 255, 255, 0.3);
                border-radius: 20px;
                position: relative;
              "
              class="container-fluid"
            >
              <div class="mt-4" style="position: relative">
                <img
                  class="imgMapResponsive"
                  src="../../../../assets/images/kubota/mapoverview.gif"
                />
              </div>
            </vs-card>
            <vs-row vs-type="flex" vs-justify="space-between" vs-w="12">
              <vs-col
                style="padding-left: 0"
                vs-type="flex"
                vs-justify="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card class="borderRD">
                  <vs-row>
                    <h3
                      class="mb-2 mt-1"
                      style="font-weight: 800; font-size: 1vw"
                    >
                      O<sub>2</sub>, PM2.5, PM10, O<sub>3</sub>, N<sub>2</sub>O,
                      CO<sub>2</sub> & CH<sub>4</sub>
                    </h3>
                    <vs-spacer />
                    <vs-select
                      class="selectExample"
                      @change="selectDataGraph(selectData, index)"
                      v-model="selectData"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                        v-for="(item, index) in options1" /></vs-select
                  ></vs-row>
                  <div style="position: relative; width: 100%">
                    <LineChart
                      :width="800"
                      :height="height_graph"
                      :chartData="datacollection"
                      :options="options"
                    ></LineChart></div
                ></vs-card>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
              >
                <img
                  style="width: 100%"
                  src="../../../../assets/images/kubota/Group 5319.png"
                /> </vs-col
            ></vs-row>
          </vs-row>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-lg="5"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-row>
            <vs-row
              v-if="get_data.aqi <= 25"
              style="position: relative"
              class="mb-1"
            >
              <img
                style="width: 100%; top: 0; left: 0"
                src="../../../../assets/images/kubota/airQ/Group 5358.png"
              />
              <div
                align="center"
                style="position: absolute; width: 100px; top: 12%; left: 27%"
              >
                <h1 style="font-weight: 800; color: #061d61; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; top: 50%; left: 50%">
                <h1
                  style="
                    font-weight: 800;
                    text-transform: uppercase;
                    color: #061d61;
                    font-size: 3vw;
                  "
                >
                  Excellent
                </h1>
              </div>
            </vs-row>
            <vs-row
              v-if="25 < get_data.aqi && get_data.aqi <= 50"
              style="position: relative"
              class="mb-1"
            >
              <img
                style="width: 100%; top: 0; left: 0"
                src="../../../../assets/images/kubota/airQ/Group 5357.png"
              />
              <div style="position: absolute; top: 12%; left: 27%">
                <h1 style="font-weight: 800; color: #1b6106; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; top: 50%; left: 55%">
                <h1 style="font-weight: 800; color: #1b6106; font-size: 3vw">
                  GOOD
                </h1>
              </div>
            </vs-row>
            <vs-row
              v-if="50 < get_data.aqi && get_data.aqi <= 100"
              style="position: relative"
              class="mb-1"
            >
              <img
                style="width: 100%; top: 0; left: 0"
                src="../../../../assets/images/kubota/airQ/Group 5356.png"
              />
              <div
                align="center"
                style="position: absolute; width: 100px; top: 12%; left: 27%"
              >
                <h1 style="font-weight: 800; color: #5f6106; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; top: 50%; left: 50%">
                <h1 style="font-weight: 800; color: #5f6106; font-size: 2.5vw">
                  MODERATE
                </h1>
              </div>
            </vs-row>
            <vs-row
              v-if="100 < get_data.aqi && get_data.aqi <= 200"
              style="position: relative"
              class="mb-1"
            >
              <img
                style="width: 100%; top: 0; left: 0"
                src="../../../../assets/images/kubota/airQ/Group 5360.png"
              />
              <div
                align="center"
                style="position: absolute; width: 100px; top: 10%; left: 24%"
              >
                <h1 style="font-weight: 800; color: #613706; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; top: 50%; left: 50%">
                <h1
                  style="
                    font-weight: 800;
                    text-transform: uppercase;
                    color: #613706;
                    font-size: 2.6vw;
                  "
                >
                  Unhealthy
                </h1>
              </div>
            </vs-row>
            <vs-row
              v-if="get_data.aqi > 200"
              style="position: relative"
              class="mb-1"
            >
              <img
                style="width: 100%; top: 0; left: 0"
                src="../../../../assets/images/kubota/airQ/Group 5359.png"
              />
              <div
                align="center"
                style="position: absolute; width: 100px; top: 10%; left: 24%"
              >
                <h1 style="font-weight: 800; color: #610e06; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; width: 100%; top: 50%; left: 45%">
                <h1
                  style="
                    font-weight: 800;
                    text-transform: uppercase;
                    color: #610e06;
                    font-size: 2vw;
                  "
                >
                  Very Unhealthy
                </h1>
              </div>
            </vs-row>

            <div class="centerHeader container">
              <h4 style="font-size: 1.4rem; font-weight: 500">
                Real Time Weather Conditions
              </h4>
            </div>
            <WeatherConditions :get_data="get_data" />

            <div class="centerHeader mb-2 container">
              <h4 style="font-size: 1.4rem; font-weight: 500">
                Real Time Air Pollution
              </h4>
            </div>

            <o2 :get_data="get_data" />
            <!-- <vs-card class="borderRD">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
              >
                <h4 style="font-size: 1rem; font-weight: 400">Real time Air Pullution</h4>
              </vs-col>
            </vs-card> -->
            <vs-row
              class="mt-2"
              vs-align="flex-end"
              vs-type="flex"
              vs-justify="space-between"
              vs-w="12"
            >
              <vs-col
                style="position: relative"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <div style="position: absolute; top: 2%; left: 7%">
                  <img
                    style="height: 30%; width: 30%"
                    src="../../../../assets/images/kubota/h gif/200-2.gif"
                  />
                </div>
                <div>
                  <img
                    v-if="get_data.pm25 <= 25"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png"
                  />
                  <img
                    v-if="25 < get_data.pm25 && get_data.pm25 <= 37"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5336.png"
                  />
                  <img
                    v-if="37 < get_data.pm25 && get_data.pm25 <= 50"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png"
                  />
                  <img
                    v-if="50 < get_data.pm25 && get_data.pm25 <= 90"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5340.png"
                  />
                  <img
                    v-if="get_data.pm25 > 90"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Moon and Stairs Mystical Logo Template (9).png"
                  />
                </div>

                <div style="position: absolute; top: 8%; left: 39%">
                  <h2 style="font-size: 1.6rem; font-weight: 800">PM 2.5</h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.pm25 <= 25" class="mr-2 pTextSize pTextL1">
                    {{ get_data.pm25 }}
                  </h1>
                  <h1
                    v-if="25 < get_data.pm25 && get_data.pm25 <= 37"
                    class="mr-2 pTextSize pTextL2"
                  >
                    {{ get_data.pm25 }}
                  </h1>
                  <h1
                    v-if="37 < get_data.pm25 && get_data.pm25 <= 50"
                    class="mr-2 pTextSize pTextL3"
                  >
                    {{ get_data.pm25 }}
                  </h1>
                  <h1
                    v-if="50 < get_data.pm25 && get_data.pm25 <= 90"
                    class="mr-2 pTextSize pTextL4"
                  >
                    {{ get_data.pm25 }}
                  </h1>
                  <h1 v-if="get_data.pm25 > 90" class="mr-2 pTextSize pTextL5">
                    {{ get_data.pm25 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">
                    µg./m <sup>3</sup>
                  </h2>
                </div>
                <div
                  style="
                    position: absolute;
                    text-align: center;
                    bottom: -5.5%;
                    margin: 10%;
                  "
                >
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ฝุ่นละอองขนาดเล็กไม่เกิน 2.5 ไมครอน
                  </h6>
                </div>
              </vs-col>
              <vs-col
                style="position: relative"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <div style="position: absolute; top: 0%; left: 5.5%">
                  <img
                    style="height: 30%; width: 30%"
                    src="../../../../assets/images/kubota/h gif/bubbles.gif"
                  />
                </div>
                <div>
                  <img
                    v-if="get_data.pm10 <= 50"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png"
                  />
                  <img
                    v-if="50 < get_data.pm10 && get_data.pm10 <= 80"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5336.png"
                  />
                  <img
                    v-if="80 < get_data.pm10 && get_data.pm10 <= 120"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png"
                  />
                  <img
                    v-if="120 < get_data.pm10 && get_data.pm10 <= 180"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5340.png"
                  />
                  <img
                    v-if="get_data.pm10 > 180"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Moon and Stairs Mystical Logo Template (9).png"
                  />
                </div>

                <div style="position: absolute; top: 8%; left: 39%">
                  <h2 style="font-size: 1.6rem; font-weight: 800">PM 10</h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.pm10 <= 50" class="mr-2 pTextSize pTextL1">
                    {{ get_data.pm10 }}
                  </h1>
                  <h1
                    v-if="50 < get_data.pm10 && get_data.pm10 <= 80"
                    class="mr-2 pTextSize pTextL2"
                  >
                    {{ get_data.pm10 }}
                  </h1>
                  <h1
                    v-if="80 < get_data.pm10 && get_data.pm10 <= 120"
                    class="mr-2 pTextSize pTextL3"
                  >
                    {{ get_data.pm10 }}
                  </h1>
                  <h1
                    v-if="120 < get_data.pm10 && get_data.pm10 <= 180"
                    class="mr-2 pTextSize pTextL4"
                  >
                    {{ get_data.pm10 }}
                  </h1>
                  <h1 v-if="get_data.pm10 > 180" class="mr-2 pTextSize pTextL5">
                    {{ get_data.pm10 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">
                    µg./m <sup>3</sup>
                  </h2>
                </div>
                <div
                  style="
                    position: absolute;
                    text-align: center;
                    bottom: -4.5%;
                    margin: 10%;
                  "
                >
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ฝุ่นละอองขนาดเล็กไม่เกิน 10 ไมครอน
                  </h6>
                </div>
              </vs-col>
              <vs-col
                style="position: relative"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <div style="position: absolute; top: 1%; left: 2.5%">
                  <img
                    style="height: 40%; width: 40%"
                    src="../../../../assets/images/kubota/h gif/sd.gif"
                  />
                </div>
                <div>
                  <img
                    v-if="get_data.o3 <= 35"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png"
                  />
                  <img
                    v-if="35 < get_data.o3 && get_data.o3 <= 50"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5336.png"
                  />
                  <img
                    v-if="50 < get_data.o3 && get_data.o3 <= 70"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png"
                  />
                  <img
                    v-if="70 < get_data.o3 && get_data.o3 <= 120"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5340.png"
                  />
                  <img
                    v-if="get_data.o3 > 120"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Moon and Stairs Mystical Logo Template (9).png"
                  />
                </div>

                <div style="position: absolute; top: 8%; text-align: center">
                  <h2 style="font-size: 1.6rem; font-weight: 800">
                    O<sub>3</sub>
                  </h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.o3 <= 35" class="mr-2 pTextSize pTextL1">
                    {{ get_data.o3 }}
                  </h1>
                  <h1
                    v-if="35 < get_data.o3 && get_data.o3 <= 50"
                    class="mr-2 pTextSize pTextL2"
                  >
                    {{ get_data.o3 }}
                  </h1>
                  <h1
                    v-if="50 < get_data.o3 && get_data.o3 <= 70"
                    class="mr-2 pTextSize pTextL3"
                  >
                    {{ get_data.o3 }}
                  </h1>
                  <h1
                    v-if="70 < get_data.o3 && get_data.o3 <= 120"
                    class="mr-2 pTextSize pTextL4"
                  >
                    {{ get_data.o3 }}
                  </h1>
                  <h1 v-if="get_data.o3 > 120" class="mr-2 pTextSize pTextL5">
                    {{ get_data.o3 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">ppb</h2>
                </div>
                <div
                  style="
                    position: absolute;
                    text-align: center;
                    bottom: -5.5%;
                    margin: 10%;
                  "
                >
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ก๊าซโอโซน
                  </h6>
                </div>
              </vs-col>
            </vs-row>
            <vs-row
              class="mt-2"
              vs-align="center"
              vs-type="flex"
              vs-justify="space-around"
              vs-w="12"
            >
              <vs-col
                style="position: relative"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <div style="position: absolute; top: 1%; left: 10%">
                  <img
                    style="height: 20%; width: 30%"
                    src="../../../../assets/images/kubota/h gif/output-onlinegiftools (33).gif"
                  />
                </div>
                <div>
                  <img
                    v-if="get_data.no2 < 50"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png"
                  />
                  <img
                    v-if="get_data.no2 >= 50"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png"
                  />
                </div>

                <div style="position: absolute; top: 8%; text-align: center">
                  <h2 style="font-size: 1.6rem; font-weight: 800">
                    N<sub>2</sub>O
                  </h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.no2 < 50" class="mr-2 pTextL1 pTextSize">
                    {{ get_data.no2 }}
                  </h1>
                  <h1 v-if="get_data.no2 >= 50" class="mr-2 pTextL3 pTextSize">
                    {{ get_data.no2 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">ppm</h2>
                </div>
                <div
                  style="
                    position: absolute;
                    text-align: center;
                    bottom: -4.5%;
                    margin: 10%;
                  "
                >
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ไนตรัสออกไซด์
                  </h6>
                </div>
              </vs-col>
              <vs-col
                style="position: relative"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <div style="position: absolute; top: 1%; left: 8%">
                  <img
                    style="height: 20%; width: 35%"
                    src="../../../../assets/images/kubota/h gif/210319adcffc99fe1a3ad496bae53d98.gif"
                  />
                </div>
                <div>
                  <!-- <img
                    v-if="get_data.co2 <= 4.4"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png"
                  />
                  <img
                    v-if="4.4 < get_data.co2 && get_data.co2 <= 6.4"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5336.png"
                  />
                  <img
                    v-if="6.4 < get_data.co2 && get_data.co2 <= 9"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png"
                  />
                  <img
                    v-if="9 < get_data.co2 && get_data.co2 <= 30"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5340.png"
                  />
                  <img
                    v-if="get_data.co2 > 30"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Moon and Stairs Mystical Logo Template (9).png"
                  /> -->
                  <img
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png"
                  />
                </div>

                <div style="position: absolute; top: 8%; text-align: center">
                  <h2 style="font-size: 1.6rem; font-weight: 800">
                    CO<sub>2</sub>
                  </h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 class="mr-2 pTextSize pTextL1">553</h1>
                  <!-- <h1 v-if="get_data.co2 <= 4.4" class="mr-2 pTextSize pTextL1">
                    {{ get_data.co2 }}
                  </h1>
                  <h1
                    v-if="4.4 < get_data.co2 && get_data.co2 <= 6.4"
                    class="mr-2 pTextSize pTextL2"
                  >
                    {{ get_data.co2 }}
                  </h1>
                  <h1
                    v-if="6.4 < get_data.co2 && get_data.co2 <= 9"
                    class="mr-2 pTextSize pTextL3"
                  >
                    {{ get_data.co2 }}
                  </h1>
                  <h1
                    v-if="9 < get_data.co2 && get_data.co2 <= 30"
                    class="mr-2 pTextSize pTextL4"
                  >
                    {{ get_data.co2 }}
                  </h1>
                  <h1 v-if="get_data.co2 > 30" class="mr-2 pTextSize pTextL5">
                    {{ get_data.co2 }}
                  </h1> -->
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">ppm</h2>
                </div>
                <div
                  style="
                    position: absolute;
                    text-align: center;
                    bottom: -4.5%;
                    margin: 10%;
                  "
                >
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ก๊าซคาร์บอนไดออกไซด์
                  </h6>
                </div>
              </vs-col>
              <vs-col
                style="position: relative"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <div style="position: absolute; top: 0%; left: 11%">
                  <img
                    style="height: 40%; width: 25%"
                    src="../../../../assets/images/kubota/h gif/ezgif.com-gif-maker (7).gif"
                  />
                </div>
                <div>
                  <img
                    v-if="get_data.ch4 < 1000"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png"
                  />
                  <img
                    v-if="get_data.ch4 >= 1000"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png"
                  />
                </div>

                <div style="position: absolute; top: 8%; text-align: center">
                  <h2 style="font-size: 1.6rem; font-weight: 800">
                    CH<sub>4</sub>
                  </h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.ch4 < 1000" class="mr-2 pTextSize pTextL1">
                    {{ get_data.ch4 }}
                  </h1>
                  <h1
                    v-if="get_data.ch4 >= 1000"
                    class="mr-2 pTextSize pTextL3"
                  >
                    {{ get_data.ch4 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">ppm</h2>
                </div>

                <div
                  style="
                    position: absolute;
                    text-align: center;
                    bottom: -4.5%;
                    margin: 10%;
                  "
                >
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ก๊าซมีเทน
                  </h6>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mt-1">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
              >
                <img
                  style="width: 100%"
                  src="../../../../assets/images/kubota/Group 5320.png"
                /> </vs-col
            ></vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import PureVueChart from "pure-vue-chart";
import LineChart from "../kubota/Chart";
import moment from "moment";
import WeatherConditions from "../kubota/components/WeatherConditions.vue";
import o2 from "../kubota/components/o2.vue";
// import BarChart from "./PM2.5/BarChart.vue";
// import LineChartSmall from "./PM2.5/lineChart.vue";
// import LineChart from "./PM2.5/Chart.js";
export default {
  name: "App",
  components: {
    PureVueChart,
    LineChart,
    WeatherConditions,
    o2,
  },

  data: () => ({
    get_data: {
      timestamp: "2022-07-21T16:16:55.000Z",
      wind_direction: "10.00",
      wind_speed: "3.35",
      pm25: "14.00",
      pm10: "85.04",
      o3: "79.35",
      ch4: "1007",
      no2: "90.00",
      co2: "28.85",
      temp: "26.50",
      humid: "91.45",
      co: "0.00",
      o2: "10.45",
      aqi: 149,
    },
    currentTime: "",
    interval: null,
    options1: [
      {
        text: "Daily",
        value: 2,
      },
      {
        text: "Weekly",
        value: 3,
      },
      {
        text: "Monthly",
        value: 4,
        data: [200, 101, 231, 14],
        label: ["Week 1", "Week 2", "Week 3", "Week 4"],
      },
      {
        text: "Yearly",
        value: 5,
      },
    ],
    WeatherCon: [
      {
        header: "Temperature",
        img: "../../../../assets/images/kubota/h gif/output-onlinegiftools (26).gif",
        number: "26.3",
        unit: "c",
      },
      {
        header: "Relative Humidity",
        img: "../../../../assets/images/kubota/h gif/output-onlinegiftools (26).gif",
        number: "6",
        unit: "%",
      },
      {
        header: "Wind Speed",
        img: "../../../../assets/images/kubota/h gif/output-onlinegiftools (26).gif",
        number: "1",
        unit: "m/s",
      },
    ],
    showIcon: true,
    selectDataCompare1: 3,
    selectDataCompare2: 3,
    selectDataYearly: 0,
    optionsCompare1: [
      { text: "Daily", value: 0 },
      { text: "Monthly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    optionsCompare2: [
      { text: "Daily", value: 0 },
      { text: "Monthly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    optionsCompareYearly: [
      { text: "2020", value: 0 },
      { text: "2019", value: 2 },
      { text: "2018", value: 3 },
      { text: "2017", value: 2 },
      { text: "2016", value: 3 },
    ],
    options: null,
    selectData: 3,
    users: [
      {
        id: 1,
        name: "NO2",
        number: "4",
      },
      {
        id: 2,
        name: "O2",
        number: "6",
      },
      {
        id: 3,
        name: "SO2",
        number: "1",
      },
    ],
    users2: [
      {
        id: 1,
        name: "Temp",
        number: "4",
      },
      {
        id: 2,
        name: "Humidity",
        number: "6",
      },
      {
        id: 3,
        name: "Wind",
        number: "1",
      },
    ],
    chartDataTime1: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime2: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime3: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime4: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime5: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime6: { daily: [], weekly: [], monthly: [], yearly: [] },
    labelInput: [],
    labelInputTime: { daily: [], weekly: [], monthly: [], yearly: [] },
    height: 300,
    datacollection: null,
    gradient: null,
    intervalid1: null,
    intervaltime: null,
    intervaltime2: null,
    changes: null,
    airq: "",
    data_graph: [],
    height_graph: null,
  }),
  methods: {
    increase() {
      this.height += 10;
    },
    hideshow() {
      var cells = document.getElementById("tab").getElementsByTagName("td"),
        i = 0,
        c;
      var chb = document
        .getElementById("chboxes")
        .getElementsByTagName("input");
      while ((c = cells[i++])) {
        c.style.display = chb[c.cellIndex].checked ? "" : "none";
      }
    },
    setEvent() {
      var chb = document
          .getElementById("chboxes")
          .getElementsByTagName("input"),
        i = 0,
        c;
      while ((c = chb[i++])) {
        if (c.type == "checkbox") {
          c.onclick = function () {
            hideshow();
          };
        }
      }
    },
    gfg_Run() {
      let el_down = Array.from(
        {
          length: 7,
        },
        () => Math.floor(Math.random() * 10)
      );
      return el_down;
    },
    selectDataGraph(item) {
      // console.log(item);
      // console.log(this.gfg_Run());
      this.datacollection = {
        labels: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        datasets: [
          {
            label: "PM 2.5",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: this.gfg_Run(),
            borderWidth: 2,
            borderColor: "rgba(172, 0, 252,.9)",
          },
          {
            label: "PM 10",
            data: this.gfg_Run(),
            backgroundColor: "rgba(20, 153, 242,.0)",
            borderWidth: 2,
            borderColor: "rgba(20, 153, 242,.9)",
          },
          {
            label: "O3",
            backgroundColor: "rgba(255, 0, 0,.0)",
            data: this.gfg_Run(),
            borderWidth: 2,
            borderColor: "rgba(250, 128, 114,.9)",
          },
          {
            label: "N2O",
            data: this.gfg_Run(),
            backgroundColor: "rgba(20, 153, 242,.0)",
            borderWidth: 2,
            borderColor: "rgba(211, 84, 0,.9)",
          },
          {
            label: "CO2",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: this.gfg_Run(),
            borderWidth: 2,
            borderColor: "rgba(241, 196, 15,.9)",
          },
          {
            label: "CH4",
            data: this.gfg_Run(),
            backgroundColor: "rgba(20, 153, 242,.0)",
            borderWidth: 2,
            borderColor: "rgba(22, 160, 133,.9)",
          },
        ],
      };
      this.options = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
        },
      };
    },
    getLabel(num) {
      return moment(num).format("dddd");
    },

    hideSideBar(id) {
      var element = document.getElementById(id);
      this.showIcon = false;
      // Supports most browsers and their versions.
      var requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullScreen;

      if (requestMethod) {
        // Native full screen.
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== "undefined") {
        // Older IE.
        var wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    showSideBar() {
      this.showIcon = true;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },

    argMax1(array) {
      console.log(array);
      return array
        .map((x, i) => [x, i])
        .reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    },
    argMax2(array) {
      console.log(array);
      return array
        .map((x, i) => [x, i])
        .reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
  },
  async mounted() {
    this.currentTime = this.$moment().format("DD/MM/YYYY HH:mm:ss");

    this.selectDataGraph(this.selectData);

    this.intervaltime = setInterval(async () => {
      this.currentTime = this.$moment().format("DD/MM/YYYY HH:mm:ss");
    }, 1000);
  },
  beforeDestroy() {
    clearTimeout(this.interval);
    clearInterval(this.intervaltime);
    clearTimeout(this.intervaltime2);
  },
  created() {
    console.log(window.innerWidth);
    if (window.innerWidth < 1550) {
      this.height_graph = 240;
    } else if (window.innerWidth > 1550) {
      this.height_graph = 320;
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    myStyles() { 
      return {
        // height: `${this.height}px`,
        position: "relative",
        color: "linear-gradient(#e66465, #9198e5)",
      };
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Charm:wght@700&family=Kodchasan:wght@500&display=swap");
.small {
  max-width: 800px;
  height: 450px;
}
.thFontthai {
  font-family: "Charm", cursive;
  font-family: "Kodchasan", sans-serif;
}
.icon1 {
  position: absolute;
  cursor: pointer;
  top: 59%;
  right: 9.5%;
  z-index: 100;
}
.icon2 {
  position: absolute;
  cursor: pointer;
  top: 68%;
  right: 16.7%;
  z-index: 100;
}
.icon3 {
  position: absolute;
  cursor: pointer;
  top: 24%;
  right: 31.5%;
  z-index: 100;
}
.icon4 {
  position: absolute;
  cursor: pointer;
  top: 17%;
  right: 41.5%;
  z-index: 100;
}
.icon5 {
  position: absolute;
  cursor: pointer;
  top: 34%;
  left: 43.5%;
  z-index: 100;
}
.icon6 {
  position: absolute;
  cursor: pointer;
  top: 60%;
  right: 36.5%;
  z-index: 100;
}
.icon7 {
  position: absolute;
  cursor: pointer;
  top: 46%;
  right: 13%;
  z-index: 100;
}
.icon8 {
  position: absolute;
  cursor: pointer;
  top: 49%;
  right: 3%;
  z-index: 100;
}
.small {
  max-width: 800px;
  height: 450px;
}
.inner-div1 {
  width: 100%;
  height: 100%;
  z-index: 1;
  padding: 5px 10px;
  margin-right: 0px;
  float: left;
  background: #caebbd;
  /* background-image: url("../../../../assets/images/kubota/131_1.jpg"); */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.imgMapResponsive {
  display: block;
  height: 36vh;
  width: 100%;
  top: 0;
  left: 0;
}
.pTextSize {
  font-size: 3vw;
  font-weight: 800;
}
.pTextL1 {
  color: #0cbbc4;
}
.pTextL2 {
  color: #2bc40c;
}
.pTextL3 {
  color: #c4b50c;
}
.pTextL4 {
  color: #c47d0c;
}
.pTextL5 {
  color: #c41c0c;
}
@media only screen and (max-width: 600px) {
  .inner-div1 {
    background-image: none;
  }
}
.hidden {
  display: inline-block;
}
div.con {
  background-image: url("../../../../assets/images/Enco/Rectangle -10.png");
}
.opacityCard {
  opacity: 0.8;
}
.a {
  background: #caebbd;
  padding: 5px;
  border-radius: 5px;
  height: 45%;
}
.b {
  background: #fbe988;
  padding: 5px;
  border-radius: 5px;
  height: 45%;
}
.w {
  background-image: url("../../../../assets/images/Enco/Rectangle 1718.png");
}
.bg-div2 {
  background: #caebbd;
  width: 100%;
  border-radius: 20px;
  height: 100%;
  text-align: center;
}
.ug-detail {
  margin-top: 1.3rem;
  margin-bottom: 0rem;
  font-size: 0.8rem;
}
.borderRD {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  margin-bottom: 0;
}
.borderGreen {
  background: rgba(50, 192, 64, 0.3);
  position: relative;
  height: 100%;
}
.al-center {
  align-items: center;
}
.brdbtn {
  width: 80px;
  border-radius: 20px;
}
.img {
  width: 30px;
  height: 30px;
  display: inline-block;
  -webkit-mask: url("../../../../assets/images/kubota/1x/baseline_zoom_in_map_black_24dp.png")
    center/contain;
  mask: url("../../../../assets/images/kubota/1x/baseline_zoom_in_map_black_24dp.png")
    center/contain;
  color: rgba(255, 255, 255, 0);
  cursor: pointer;
}
.img:hover {
  background: #000000;
}
.centerHeader {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 5px;
}
</style>
